export class EmergencyAccessConfirmRequest {
  key: string;
}
